export function stickyStyled(target) {

  console.log("stickyStyled)");
  // console.log("stickyStyled)");

  
  // const stickyEl = document.querySelector('.target');
  const stickyEl = target;
  const parentEl = stickyEl.closest(".parent");
  const prevParentSiblingEl = parentEl.previousElementSibling;
  
  const handler = (entries) => {
    // console.log(entries)
  
    if (!entries[0].isIntersecting) {
      stickyEl.classList.add('--is-sticky');
      parentEl.classList.add('--parent-is-sticky');     
      // document.querySelector('.target').innerHTML = "Now Sticky Styled";
  
     } else {
      stickyEl.classList.remove('--is-sticky');
      parentEl.classList.remove('--parent-is-sticky');
      // document.querySelector('.target').innerHTML = "Not Sticky Styled";
  
    }
  }
  
  // create the observer
  const observer = new window.IntersectionObserver(handler);
  // give the observer some dom nodes to keep an eye on
  observer.observe(prevParentSiblingEl);



}